<template>
  <div>
    <el-dialog
      v-model="dialogFormVisible"
      :close-on-click-modal="false"
      :title="title"
      width="80%"
      @close="close"
    >
      <el-form ref="formRef" label-width="120px" :model="form" :rules="rules">
        <el-form-item label="员工" prop="peopleId">
          <el-select
            v-model="form.peopleId"
            placeholder="请选择员工"
            class="fix-width"
            clearable
          >
            <el-option
              v-for="item in staffList"
              :key="item.peopleId"
              :label="item.basic.name"
              :value="item.peopleId"
            ></el-option>
          </el-select>
        </el-form-item>
          <el-form-item label="年份">
            <el-date-picker
              v-model="form.year"
              type="year"
              placeholder="选择年"
              value-format="YYYY"
            ></el-date-picker>
          </el-form-item>
        <el-form-item label="总可请假天数" prop="totalCount">
          <el-input-number
            v-model="form.totalCount"
            class="fix-width"
            placeholder="请输入总可请假天数"
          />
        </el-form-item>
        <el-form-item label="目前已请假天数" prop="usedCount">
          <el-input-number
            v-model="form.usedCount"
            class="fix-width"
            placeholder="请输入目前已请假天数"
          />
        </el-form-item>
        <el-form-item label="目前请假中天数" prop="pendingCount">
          <el-input-number
            v-model="form.pendingCount"
            class="fix-width"
            placeholder="请输入目前请假中天数"
          />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="close(formRef)">取 消</el-button>
        <el-button type="primary" @click="save(formRef)">确 定</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { createVacation, updateVacation } from '@/api/oa'
import commomFunction from '../common'
import { ref, reactive, getCurrentInstance } from 'vue'
export default {
  name: 'OaVacationEdit',
  emits: ['fetch-data'],
  setup(_, { emit }) {
    const { proxy } = getCurrentInstance()
    const title = ref('')
    const dialogFormVisible = ref(false)
    const formRef = ref(null)
    const { branchList, staffList, rateCodeList } = commomFunction()
    const initForm = () => {
      return {
        vacationId: '',
        peopleId: '',
        year: '',
        totalCount: 0,
        usedCount: 0,
        pendingCount: 0,
      }
    }
    const form = reactive(initForm())
    const rules = {
      peopleId: [{ required: true, trigger: 'blur', message: '请选择员工' }],
    }
    const showEdit = async (row) => {
      if (row && row.vacationId) {
        title.value = '修改人员请假天数'
        form.vacationId = row.vacationId
        form.peopleId = row.basic.peopleId
        form.year = row.basic.year
        form.totalCount = row.basic.totalCount
        form.usedCount = row.basic.usedCount
        form.pendingCount = row.basic.pendingCount
      } else {
        title.value = '新增人员请假天数'
      }
      dialogFormVisible.value = true
    }
    const formReset = (formRef) => {
      if (!formRef) return
      formRef.resetFields()
      Object.assign(form,initForm())
    }
    const close = (formRef) => {
      formReset(formRef)
      dialogFormVisible.value = false
    }
    const save = (formRef) => {
      if (!formRef) return
      formRef.validate(async (valid) => {
        if (valid) {
          const vacationId = form.vacationId
          const data = Object.assign({}, form)
          proxy.$baseConfirm(
            `你确定要${vacationId ? '修改' : '新增'}人员请假天数吗`,
            null,
            async () => {
              vacationId
                ? await updateVacation(data)
                : await createVacation(data)
              proxy.$baseMessage(
                `${vacationId ? '修改' : '新增'}人员请假天数成功`,
                'success',
                false,
                'vab-hey-message-success'
              )
              emit('fetch-data')
              close(formRef)
            }
          )
        } else {
          return false
        }
      })
    }
    return {
      title,
      branchList,
      formRef,
      form,
      rules,
      dialogFormVisible,
      staffList,
      rateCodeList,
      showEdit,
      close,
      save,
    }
  },
}
</script>

<style lang="scss" scoped>
@mixin size($scale: 1, $type: small) {
  @if $type == large {
    width: 343px * $scale;
  } @else {
    width: 167px * $scale;
  }
  height: 167px * $scale;
}
.avatar-uploader {
  .avatar {
    border-radius: 6px;
    transition: all 0.3s ease-in-out;
    @include size;

    &.large {
      @include size(1, large);
    }
  }
}
.icon_avatar {
  width: 50px;
  height: 50px;
}
.avatar-uploader-icon {
  border: 1px dashed #c0ccda;
  background-color: #fbfdff;
  border-radius: 6px;
  font-size: 28px;
  color: #8c939d;
  width: 148px;
  height: 148px;
  line-height: 148px;
  text-align: center;
}
.tags {
  margin-bottom: 5px;
}
.tags + .tags,
.tags + .button-new-tag {
  margin-left: 10px;
}
.button-new-tag {
  // margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
.disabled .el-upload--picture-vacationd {
  display: none;
}
.fix-width {
  width: 500px;
}
.mb-10 {
  margin-bottom: 10px;
}
.tips {
  color: #aaaaaa;
  margin-left: 50px;
}
.el-icon-circle-plus-outline,
.el-icon-remove-outline {
  font-size: 32px;
  vertical-align: middle;
  cursor: pointer;
}

.el-icon-circle-plus-outline {
  color: #409eff;
}

.el-icon-remove-outline {
  color: #f56c6c;
  margin-left: 15px;
}

.mr-10 {
  margin-right: 10px;
}
.mb-10 {
  margin-bottom: 10px;
}
</style>
